import React from 'react';

const CampaignPerformance = ({ data }) => {
  if (!data) return null;
  const { influencersEvaluated, avgEMVPerDollar, topInfluencer, campaignFit } = data;

  return (
    <div className="performance-section">
      <h2 className="performance-title">Campaign Performance</h2>

      <div className="performance-grid">
        <div className="performance-card">
          <div className="performance-card-header">
            <span className="performance-card-label">Influencers Evaluated</span>
            <span className="performance-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
          </div>
          <div className="performance-card-value">{influencersEvaluated.count}</div>
          <div className="performance-card-desc">{influencersEvaluated.description}</div>
        </div>

        <div className="performance-card">
          <div className="performance-card-header">
            <span className="performance-card-label">Avg EMV per $</span>
            <span className="performance-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v12" />
                <path d="M8 10h8" />
                <path d="M8 14h8" />
              </svg>
            </span>
          </div>
          <div className="performance-card-value">{avgEMVPerDollar.amount}</div>
          <div className="performance-card-desc">{avgEMVPerDollar.description}</div>
        </div>

        <div className="performance-card">
          <div className="performance-card-header">
            <span className="performance-card-label">Top Influencer</span>
            <span className="performance-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
                <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
                <path d="M4 22h16" />
                <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
                <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
                <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
              </svg>
            </span>
          </div>
          <div className="performance-card-value">{topInfluencer.name}</div>
          <div className="performance-card-subtitle">IFS {topInfluencer.ifsScore}</div>
          <div className="performance-card-desc">Rank {topInfluencer.rank}</div>
        </div>

        <div className="performance-card">
          <div className="performance-card-header">
            <span className="performance-card-label">Campaign Fit</span>
            <span className="performance-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="m2 12 5.5 5.5L22 3" />
              </svg>
            </span>
          </div>
          <div className="performance-card-value">{campaignFit.percentage}</div>
          <div className="performance-card-desc">{campaignFit.description}</div>
        </div>
      </div>
    </div>
  );
};

export default CampaignPerformance;
